module.exports = __webpack_public_path__ + "img/Burger Menu_grey.7a8ce805.svg";